import curry from './curry';
/**
 * Curried map implementation.
 */

var map = curry(function (f, xs) {
  return xs.map(f);
});
export default map;